"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleNames = undefined;

var _assert = require("@swarm2/assert");

var _reselect = require("reselect");

var _fp = require("lodash/fp");

var _fp2 = _interopRequireDefault(_fp);

var _flags = require("../../flags");

var Flags = _interopRequireWildcard(_flags);

var _now = require("../../now");

var Now = _interopRequireWildcard(_now);

var _lifecycle = require("./_lifecycle");

var Lifecycle = _interopRequireWildcard(_lifecycle);

var _raw = require("./raw");

var Raw = _interopRequireWildcard(_raw);

var _list = require("./list");

var _list2 = _interopRequireDefault(_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterLifecycleVisible = (0, _reselect.createSelector)(Now.now, function (now) {
  return function (state) {
    var status = Lifecycle._status(state.lifecycle, now);
    return status === "open" || status === "visible";
  };
});
var filterPrerelease = (0, _reselect.createSelector)(Flags.isPrereleaseFlags, function (auth) {
  return function (state) {
    var role = _fp2.default.get("auth.role", state);
    if (!role) return true;
    if (role === "prereleaseFlags") return !!auth;
    return (0, _assert.throws)("unknown league role", role);
  };
});
var filterVoid = function filterVoid(state) {
  return !state.ruleset.isVoid;
};
var filterVisible = (0, _reselect.createSelector)(filterLifecycleVisible, filterPrerelease, function () {
  return filterVoid;
}, function (f1, f2, f3) {
  return function (state) {
    return f1(state) && f2(state) && f3(state);
  };
});

var list = function list() {
  return _list2.default;
};
var filteredList = function filteredList(filter) {
  return (0, _reselect.createSelector)(filter, list, _fp2.default.filter);
};
var visibleList = filteredList(filterVisible);
var visibleNames = exports.visibleNames = (0, _reselect.createSelector)(visibleList, _fp2.default.map("name"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/visible.js
// module id = 785
// module chunks = 0